/* globals dataLayer, angular */
(function (window, angular, undefined) {
    angular.module('formApp')
        .component('orderSummary', {
            templateUrl: 'components/order-summary/templates/order-summary.html',
            bindings: {
            allPetsHaveCover: '<',
                eQuote: '<',
                eCoverNote: '<',
                charitable: '<',
                idt: '<'
            },
            controller: ['FormService', 'formData', 'dataUtils', 'errorHandler', '$q','$rootScope', '$http', '$filter', '$scope', function (formService, formData, dataUtils, errorHandler, $q,$rootScope, $http, $filter, $scope) {
                var ctrl = this;
                ctrl.ordersummary = true;
                ctrl.formData = formData;
            ctrl.getProductTitle = dataUtils.getProductTitle;
            ctrl.currentRefreshState = sessionStorage.getItem('currentRefreshState');
            ctrl.quoteExpiredFlag = sessionStorage.getItem("quoteExpiredFlag");

                var width = window.screen.width * window.devicePixelRatio;
            if (width && width < 1199 && (ctrl.currentRefreshState === 'step-5' || ctrl.currentRefreshState === 'step-5e' || ctrl.currentRefreshState === 'pay-ec')) {
                    ctrl.ordersummary = false;
                }

                ctrl.getIfsPet = function(pet) {
                    return ctrl.formData.runningTotals.pets.filter( function(item) {
                        return pet.uri === item.pet;
                    })[0];
                };
                $scope.$watch(angular.bind(this, function () {
                    return this.ifsPetData.charitableDonation;
                  }), function (newValue, oldValue) {
                      if (newValue !== oldValue) {
                        //   console.log('old');
                        ctrl.ordersummary = true;
                      }
                  });

                ctrl.$doCheck = function () {
                    // something...
                    ctrl.hasEssentialCover = false;
                    ctrl.hasC4lCover = false;
                    ctrl.hasC4lCoverRabbit = false;
                    getSummarySuccess({data: ctrl.formData.runningTotals});
                };

                var requests = [],
                products,
                ipids = [];                   

                function clearRequest(request) {
                    requests.splice(requests.indexOf(request), 1);
                }
                
                function cancel() {
                    if (requests) {
                        angular.forEach(requests, function(request) {
                            request.cancel();
                            clearRequest(request);
                        });
                    }
                }

                function getSummarySuccess(response) {
                    if(response === 'CANCELLED') {
                        return;
                    }
                    // console.log('data', response.data.products);
                    var products = response.data.products;
                    ctrl.ifsPetData = [];
                    ctrl.formData.pets.forEach(function(item) {
                        var pet = item;

                        // set c4L/essential flags
                        if (pet.chosenCover) {
                            switch (pet.chosenCover.productLine.toLowerCase()) {
                                case 'essential':
                                    ctrl.hasEssentialCover = true;
                                    break;
                                case 'c4l':
                                    ctrl.hasC4lCover = true;
                                    break;
                                case 'rabbit':
                                    ctrl.hasC4lCoverRabbit = true;
                                    break;
                            }
                        } 

                        // update products data
                        // TODO - also used in step3 controller - refactor into common util
                        pet.cc = {};
                        pet.cc.hasC4l = true;
                        angular.forEach(products, function (value, key) {
                            if (pet.uri === value.pet) {
                                if (value.covers) {
                                    value.formattedCovers = convertCovers(value.covers);
                                }
                                if (value.id === 'DVA' || value.id === 'CVA') {
                                    pet.cc.essential = value;
                                }
                                if (value.id === 'DCA'|| value.id === 'CCA'|| value.id === 'RCA') {
                                    pet.cc.classic = value;
                                    if (value.unavailable) {
                                        pet.cc.hasC4l = false;
                                    }
                                }
                                if (value.id === 'DCB' || value.id === 'CCB') {
                                    pet.cc.classicPlus = value;
                                    if (value.unavailable) {
                                        pet.cc.hasC4l = false;
                                    }
                                }
                                if (value.id === 'DCC' || value.id === 'CCC') {
                                    pet.cc.ultimate = value;
                                    if (value.unavailable) {
                                        pet.cc.hasC4l = false;
                                    }
                                }
                            }
                        });

                        // get totals
                        var ifsPet = [];
                        if (ctrl.formData.runningTotals && ctrl.formData.runningTotals.pets) {
                            ifsPet = ctrl.formData.runningTotals.pets.filter(function(item) {
                               return pet.uri === item.pet;
                            });
                        } 
                        if (ifsPet.length) {
                            pet.annualPremium = ifsPet[0].annualPremium;
                            pet.monthlyPremium = ifsPet[0].monthlyPremium;
                            pet.upgradeAnnualPremium = ifsPet[0].upgradeAnnualPremium;
                            pet.upgradeMonthlyPremium = ifsPet[0].upgradeMonthlyPremium;
                            pet.totalAnnual = ifsPet[0].totalAnnual;
                            pet.totalMonthly = ifsPet[0].totalMonthly;
                        }
                        ctrl.ifsPetData.push(pet);
                    });
                    $rootScope.gaPetData =  ctrl.ifsPetData;
                    // update total for display outside directive
                    ctrl.formData.totals = {
                        total: response.data.total,
                        monthlyTotal: response.data.monthlyTotal,
                        firstInstallment: response.data.firstInstallment,
                        subsequentInstallments: response.data.subsequentInstallments
                    };

                    // set total amount depending on whether charitable donations should be displayed
                    ctrl.ifsPetData.total = ctrl.charitable && response.data.firstInstallment ? response.data.totalWithoutCharity : response.data.total;

                    ctrl.ifsPetData.monthlyTotal = ctrl.charitable && response.data.firstInstallment ? response.data.subsequentInstallments : response.data.monthlyTotal || response.data.subsequentInstallments;
                    ctrl.ifsPetData.charitableDonation = response.data.charitableDonation;
                    ctrl.ifsPetData.noOfinstalments = response.data.noOfinstalments;
                    ctrl.ifsPetData.firstInstallment = response.data.firstInstallment;
                    ctrl.ifsPetData.subsequentInstallments = response.data.subsequentInstallments;

                    // check if all pets have a discount value
                    var allHaveCover = true;
                    ctrl.ifsPetData.forEach(function(pet) {
                        if (!pet.annualPremium) {
                            allHaveCover = false;
                        }
                    });

                    if (allHaveCover) {
                        sessionStorage.setItem('hideDiscount', true);
                    }

                    // work out discounts
                    if(response.data.hasOwnProperty('discountFromRadar') && allHaveCover) {

                        var onlineDiscount,
                            multipetDiscount,
                            firstFree;

                        // show instalments value step 3
                        ctrl.instalments = response.data.noOfinstalments;
                        
                        // check percentage discount (1 month free now a hybrid will show percent not month)
                        if (response.data.discountType === 'PERCENT') {   

                            ctrl.onlineDiscountValue = response.data.discountValue;

                            // check online discount and show value
                            if(response.data.appliedDiscounts[0].discountCode) {
                                ctrl.onlineDiscount = true;
                                if(response.data.appliedDiscounts[1] === undefined){
                                    $rootScope.$broadcast("discountApplied", {type:'Online',value: response.data.discountValue});  
                                }

                                onlineDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                    return discount.discountCode === 'ONLINE';
                                });
                                ctrl.ifsPetData.monthlyDiscount = onlineDiscount[0].discountMonthlyWithIpt;
                                ctrl.ifsPetData.annualDiscount = onlineDiscount[0].discountAnnualWithIpt;    
                            }

                            // check other discounts and show values
                            if(response.data.appliedDiscounts[1] !== undefined){

                                // check month free discount 
                                if(response.data.appliedDiscounts[1].discountCode === 'MFD') {
                                    ctrl.firstFree = formData.firstFree = true;

                                    $rootScope.$broadcast("discountApplied",  {
                                        type:'OneMonthFree'
                                    });  

                                    firstFree = response.data.appliedDiscounts.filter(function(discount) {
                                        return discount.discountCode === 'MFD';
                                    });  
                                    ctrl.ifsPetData.monthlyFirstFree = firstFree[0].discountMonthlyWithIpt;
                                    ctrl.ifsPetData.annualFirstFree = firstFree[0].discountAnnualWithIpt;
                                }

                                // check multipet discount
                                if(response.data.appliedDiscounts[1].discountCode === 'MPD') {
                                    multipetDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                        return discount.discountCode === 'MPD';
                                    });
                                    if(multipetDiscount.length > 0) {
                                        ctrl.ifsPetData.multipetMonthlyDiscount = multipetDiscount[0].discountMonthlyWithIpt;
                                        ctrl.ifsPetData.multipetAnnualDiscount = multipetDiscount[0].discountAnnualWithIpt;
                                    }                                        
                                }                              
                            }
                        }

                        // check campaign code 2 months free
                        if (response.data.discountType === 'MONTH') {
                            ctrl.monthFree = formData.monthFree = true;
                            ctrl.onlineDiscountValue = response.data.discountValue;
                            onlineDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                return discount.discountCode === 'MFD';
                            });
                            ctrl.ifsPetData.monthlyDiscount = onlineDiscount[0].discountMonthlyWithIpt;
                            ctrl.ifsPetData.annualDiscount = onlineDiscount[0].discountAnnualWithIpt;
                            $rootScope.$broadcast("discountApplied", {
                                type:'TwoMonthFree'
                            });         
                        }
                        
                        // check campaign code multi pet discount
                        multipetDiscount = response.data.appliedDiscounts.filter(function(discount) {
                            return discount.discountCode === 'MPD';
                        });
                        if(multipetDiscount.length > 0) {
                            ctrl.ifsPetData.multipetMonthlyDiscount = multipetDiscount[0].discountMonthlyWithIpt;
                            ctrl.ifsPetData.multipetAnnualDiscount = multipetDiscount[0].discountAnnualWithIpt;
                        }  
         
                    }


                }

                function errorCallback(data) {
                    errorHandler.reportErrors(data,'redirect');
                }

                function getSummary() {
                    // console.log('summary');
                    $scope.hasEssentialCover = false;
                    $scope.hasC4lCover = false;
                    $scope.hasC4lCoverRabbit = false;
                    cancel();
                    var totalsPromise = formService.getRunningTotals();
                    requests.push(totalsPromise);
                    totalsPromise.then(function(response) {
                        if(response && response.data) {
                            formData.runningTotals = response.data;
                        }
                    }).catch(errorCallback);
                }

                $scope.$on('updateSummary', function(data) {
                    // console.log('fired from delete pet');
                    getSummary();
                });

                $scope.$watch('formData.runningTotals', function(newVal, oldVal) {
                    // console.log('form data', newVal, oldVal);
                    if (newVal) {                         
                        $scope.hasEssentialCover = false;
                        $scope.hasC4lCover = false;
                        $scope.hasC4lCoverRabbit = false;
                        getSummarySuccess({data: newVal});
                      
                    }
                });

                function convertCovers(obj) {
                    var returnObj = {};
                    obj.forEach(function(item) {
                        if (item.sectionLimit && item.sectionLimit !== "0") {
                            returnObj[item.sectionId] =  {
                                sectionLimit: $filter('currency')(item.sectionLimit, "£", 0),
                                amount: item.sectionOptional === 'Y' ? 'Optional cover' : $filter('currency')(item.sectionLimit, "£", 0),
                                excess: $filter('currency')(item.sectionFlatXs, "£", 0) + (item.sectionPctXs !== '0' ? ' + ' + item.sectionPctXs + '%' : '')
                            };
                        }
                    });
                    return returnObj;
                }
     
            }]
        });
})(window, window.angular);